import type { ComponentType } from "react"
import type { LucideProps } from "lucide-react"
import dynamicIconImports from "lucide-react/dynamicIconImports"

export type IconComponent = ComponentType<LucideProps>

const cache = new Map<string, IconComponent>()

/** Test-only: drop cached icon components between cases. */
export function clearLucideBulletIconCache(): void {
  cache.clear()
}

export function getCachedLucideIcon(name: string): IconComponent | undefined {
  return cache.get(name)
}

export async function loadLucideIcon(name: string): Promise<IconComponent | null> {
  const cached = cache.get(name)
  if (cached) return cached
  const loader = dynamicIconImports[name as keyof typeof dynamicIconImports]
  if (!loader) return null
  const mod = await loader()
  // Prefer default (React component). Vite chunks export both, but DynamicIcon's
  // __iconNode path is fragile across interop / preload wrappers.
  const Icon = (mod as { default?: IconComponent }).default
  if (!Icon) return null
  cache.set(name, Icon)
  return Icon
}
